import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { filter, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getCanal } from '../../store/settings/settings.selectors';
import { Canal, CEPInfoModel } from '@libs/entity-lib';
import { Observable } from 'rxjs';
import { AddressState } from '../../store/profile/profile.actions';
import { commonEnvironment } from '@libs/shared/util-environments';

@Injectable()
export class CEPService {
  private http = inject(HttpClient);
  private store = inject(Store);


  private getCanal$ = this.store.select(getCanal);
  private baseUrl: string;

  constructor() {
    this.getCanal$.pipe(
      filter((canal) => canal !== Canal.UNDEFINED),
      take(1)
    ).subscribe(canal => {
      this.setBaseUrlByCanal(canal);
    });
  }

  setBaseUrlByCanal(canal: Canal) {
    this.baseUrl = commonEnvironment.apps[canal].baseUrl;
  }

  fetchAddressByCEP(cep: string): Observable<CEPInfoModel> {
    const url = `${this.baseUrl}/public/cep/${cep}`;
    return this.http.get<CEPInfoModel>(url).pipe(map((response: any) => response));
  }

  fetchStates(): Observable<AddressState[]> {
    const url = `${this.baseUrl}/public/states`;
    return this.http.get<AddressState[]>(url).pipe(map((response: any) => response));
  }

  fetchCitiesByUf(uf: string) {
    const url = `${this.baseUrl}/public/cities?uf=${uf}`;
    return this.http.get<CEPInfoModel>(url).pipe(map((response: any) => response));
  }

}
